import { inject, Injectable } from '@angular/core';
import { AbstractControl, AsyncValidator, ValidationErrors } from '@angular/forms';
import { catchError, first, map, Observable, of, switchMap, take } from 'rxjs';
import { DatabaseModelService } from '../../services/database-model/database-model.service';
import { FIRST_OF_OBSERVABLE } from '../../models/constant/constants.constant';

@Injectable({ providedIn: 'root' })
export class TableDoesntExistValidator implements AsyncValidator {
  tableService: DatabaseModelService = inject(DatabaseModelService);

  validate(control: AbstractControl): Observable<ValidationErrors | null> {
    return control.events.pipe(
      take(FIRST_OF_OBSERVABLE),
      switchMap(() =>
        this.tableService.tableExists$(control.value).pipe(
          map(exists => (exists ? null : { tableDoesntExist: `La table ${control.value} n'existe pas.` })),
          catchError((error: Error) => of({ tableDoesntExist: error.message })),
          first()
        )
      )
    );
  }
}
